import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../../firebase";

export const useMenuItems = (activeType, setNotif) => {
  const [items, setItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "products"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        data.sort((a, b) => {
          const ta = a.createdAt?.toMillis?.() ?? 0;
          const tb = b.createdAt?.toMillis?.() ?? 0;
          return tb - ta;
        });
        setItems(data);
        setLoadingItems(false);
      },
      () => {
        setLoadingItems(false);
        setNotif?.({ type: "error", message: "S’u arrit të lexohen produktet." });
      }
    );

    return () => unsub();
  }, [setNotif]);

  const filteredItems = useMemo(() => {
    const legacyTypes = ["perfume", "watch"];
    return items.filter(
      (x) =>
        x.type === activeType ||
        (activeType === "men" && legacyTypes.includes(x.type))
    );
  }, [items, activeType]);

  return { items, filteredItems, loadingItems };
};
